module.exports = __webpack_public_path__ + "static/media/1_file_import_requirements_and_best_practices.a061ea3e.png";